define('shared/remote/payment/creditCard/update',[
    '../ajax',
    'shared/lib/deepmerge',
    '../utils',
    './convertOptionsToPayload'
], function(
    ajax,
    deepmerge,
    utils,
    convertOptionsToPayload
){

    return function(options) {
        var data = convertOptionsToPayload(options);
        return ajax({
                method: 'post',
                url: '/1/api/commerce-gateway/order/credit-card-update',
                data: data
            });
    };
});
